export default __webpack_public_path__ + "static/media/museum.ab88c60d.jpg";